<script setup>
/* global axios */
// Icerik > Istatistikler: "olustur -> planla -> yayinla -> SONUCUNU GOR"
// akisinin son adimi.
//
// Ustte hesabin secili penceredeki toplamlari, altta gonderi gonderi
// sayilar. Rakamlar Omnup'ta SAKLANMIYOR; her acilista Instagram'dan
// okunuyor. Kopyalasaydik ekranda gercekte olmayan bir erisim sayisi durur,
// kullanici da ona bakarak karar verirdi.
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import Button from 'dashboard/components-next/button/Button.vue';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import { hataMetniniCoz, zamanMetni } from './icerik-ortak';

const { t, locale } = useI18n();
const route = useRoute();

const accountId = computed(() => route.params.accountId);
const uc = computed(
  () => `/api/v1/accounts/${accountId.value}/icerik/istatistik`
);

const PENCERELER = [7, 14, 30];
const gun = ref(7);

const ozet = ref(null);
const gonderiler = ref([]);

// Gonderi basina AYRINTI: organik sayilar, reklam sayilari, reklam
// harcamasi. Tek bir 'degerler' yerine ucunu birden tutuyoruz cunku
// kullanicinin sordugu soru "bu erisimin ne kadari paradan geldi".
const medyaSayilari = ref({});

const hesaplar = ref([]);
const seciliHesap = ref('');

const yukleniyor = ref(false);
const gonderiYukleniyor = ref(false);
const seciliMedya = ref(null);
const hata = ref('');

const gorselHatasi = ref(new Set());
const gorseliGizle = id => {
  gorselHatasi.value = new Set(gorselHatasi.value).add(id);
};

// Hesap kartlari. Metrik adlari Meta'nin dondurdugu adlar; bulunmayan
// metrik icin kart "—" gosteriyor, sifir DEGIL: veri yok ile sifir ayri
// seyler ve sifir yazmak yaniltici olurdu.
const KARTLAR = [
  { alan: 'reach', anahtar: 'ICERIK.IST_ERISIM', simge: 'i-lucide-users', renk: 'text-n-blue-11' },
  { alan: 'views', anahtar: 'ICERIK.IST_GORUNUM', simge: 'i-lucide-eye', renk: 'text-n-teal-11' },
  {
    alan: 'total_interactions',
    anahtar: 'ICERIK.IST_ETKILESIM',
    simge: 'i-lucide-activity',
    renk: 'text-n-amber-11',
  },
  {
    alan: 'accounts_engaged',
    anahtar: 'ICERIK.IST_ETKILESEN',
    simge: 'i-lucide-user-check',
    renk: 'text-n-slate-11',
  },
  { alan: 'likes', anahtar: 'ICERIK.IST_BEGENI', simge: 'i-lucide-heart', renk: 'text-n-ruby-11' },
  {
    alan: 'profile_views',
    anahtar: 'ICERIK.IST_PROFIL',
    simge: 'i-lucide-id-card',
    renk: 'text-n-slate-11',
  },
];

const sayi = deger =>
  typeof deger === 'number'
    ? new Intl.NumberFormat(locale.value).format(deger)
    : '—';

const ozetDegeri = alan => sayi(ozet.value?.degerler?.[alan]);

const metinOzeti = metin => {
  const temiz = String(metin || '').trim();
  if (!temiz) return t('ICERIK.METINSIZ');
  return temiz.length > 60 ? `${temiz.slice(0, 60)}…` : temiz;
};

const ozetiYukle = async () => {
  yukleniyor.value = true;
  hata.value = '';
  try {
    const { data } = await axios.get(`${uc.value}/ozet`, {
      params: { gun: gun.value },
    });
    ozet.value = data;
  } catch (e) {
    ozet.value = null;
    hata.value = hataMetniniCoz(e, t('ICERIK.HATA_BILINMEYEN'));
  } finally {
    yukleniyor.value = false;
  }
};

const hesaplariYukle = async () => {
  try {
    const { data } = await axios.get(`${uc.value}/hesaplar`);
    hesaplar.value = data.hesaplar || [];
  } catch {
    hesaplar.value = [];
  }
};

const gonderileriYukle = async () => {
  gonderiYukleniyor.value = true;
  try {
    const { data } = await axios.get(`${uc.value}/gonderiler`, {
      params: seciliHesap.value ? { inbox_id: seciliHesap.value } : {},
    });
    gonderiler.value = data.gonderiler || [];
  } catch (e) {
    gonderiler.value = [];
  } finally {
    gonderiYukleniyor.value = false;
  }
};

const hesapDegisti = async () => {
  seciliMedya.value = null;
  medyaSayilari.value = {};
  await gonderileriYukle();
};

// Gonderi sayilari TALEP UZERINE okunuyor: her gonderi icin ayri bir Meta
// istegi gerekiyor ve elli gonderiyi birden sormak hem ekrani bekletir hem
// hiz sinirini yer.
const medyaSec = async gonderi => {
  seciliMedya.value = gonderi.medya_id;
  if (medyaSayilari.value[gonderi.medya_id]) return;

  try {
    const { data } = await axios.get(`${uc.value}/medya`, {
      params: { medya_id: gonderi.medya_id, inbox_id: gonderi.inbox_id },
    });
    medyaSayilari.value = {
      ...medyaSayilari.value,
      [gonderi.medya_id]: {
        karsilastirma: data.karsilastirma || [],
        yalnizOrganik: data.yalniz_organik || {},
        yalnizReklam: data.yalniz_reklam || {},
        harcama: data.harcama || {},
        kopyalar: data.reklam_kopyasi || [],
      },
    };
  } catch (e) {
    hata.value = hataMetniniCoz(e, t('ICERIK.HATA_BILINMEYEN'));
  }
};

const pencereDegistir = async yeni => {
  gun.value = yeni;
  await ozetiYukle();
};

const zaman = deger => (deger ? zamanMetni(deger, locale.value) : '');

// Reklama verilmemis gonderide karsilastirma tablosu gostermenin anlami
// yok; tum erisim zaten organik.
const reklamliMi = veri => (veri?.kopyalar || []).length > 0;

// Metrik adlarini ekran metnine cevirir. Meta'nin dondurdugu ham adlari
// (reach, saved...) kullaniciya gostermenin anlami yok.
const METRIK_ADI = {
  reach: 'ICERIK.IST_ERISIM',
  views: 'ICERIK.IST_GORUNUM',
  likes: 'ICERIK.IST_BEGENI',
  comments: 'ICERIK.IST_YORUM',
  saved: 'ICERIK.IST_KAYIT',
  shares: 'ICERIK.IST_PAYLASIM',
  impressions: 'ICERIK.IST_GOSTERIM',
  clicks: 'ICERIK.IST_TIKLAMA',
};

const metrikAdi = alan =>
  METRIK_ADI[alan] ? t(METRIK_ADI[alan]) : alan;

const paraMetni = veri => {
  const h = veri?.harcama || {};
  if (!h.tutar) return '';
  return `${h.tutar} ${h.para_birimi || ''}`.trim();
};

onMounted(async () => {
  await hesaplariYukle();
  await ozetiYukle();
  await gonderileriYukle();
});
</script>

<template>
  <div class="flex flex-col gap-5 p-6">
    <div class="flex flex-wrap items-center gap-3">
      <div class="flex flex-col">
        <h2 class="text-sm font-medium text-n-slate-12">
          {{ t('ICERIK.IST_BASLIK') }}
        </h2>
        <p class="text-xs text-n-slate-11">{{ t('ICERIK.IST_ACIKLAMA') }}</p>
      </div>

      <span class="grow" />

      <select
        v-if="hesaplar.length > 1"
        v-model="seciliHesap"
        class="!mb-0 !w-auto text-sm"
        @change="hesapDegisti"
      >
        <option value="">{{ t('ICERIK.YORUM_TUM_HESAPLAR') }}</option>
        <option v-for="h in hesaplar" :key="h.inbox_id" :value="h.inbox_id">
          {{ h.kullanici ? '@' + h.kullanici : h.ad }}
        </option>
      </select>

      <!-- Pencere secimi -->
      <div class="flex p-1 rounded-lg bg-n-alpha-1">
        <button
          v-for="secenek in PENCERELER"
          :key="secenek"
          type="button"
          class="px-3 py-1 text-xs rounded-md transition-colors"
          :class="
            gun === secenek
              ? 'bg-n-solid-1 text-n-slate-12 font-medium'
              : 'text-n-slate-11 hover:text-n-slate-12'
          "
          @click="pencereDegistir(secenek)"
        >
          {{ t('ICERIK.IST_GUN', { gun: secenek }) }}
        </button>
      </div>

      <Button
        size="sm"
        variant="faded"
        icon="i-lucide-refresh-cw"
        :label="t('ICERIK.YENILE')"
        :disabled="yukleniyor"
        @click="ozetiYukle"
      />
    </div>

    <p v-if="hata" class="text-sm text-n-ruby-11">{{ hata }}</p>

    <div v-if="yukleniyor" class="flex justify-center p-10">
      <Spinner class="text-n-brand" />
    </div>

    <template v-else-if="ozet">
      <!-- Profil sayilari -->
      <section
        v-if="ozet.profil && ozet.profil.kullanici"
        class="flex flex-wrap items-center gap-6 p-4 border rounded-xl border-n-weak bg-n-solid-1"
      >
        <span class="text-sm font-medium text-n-slate-12">
          @{{ ozet.profil.kullanici }}
        </span>
        <span class="text-xs text-n-slate-11">
          {{ t('ICERIK.IST_TAKIPCI') }}:
          <span class="font-medium text-n-slate-12">
            {{ sayi(ozet.profil.takipci) }}
          </span>
        </span>
        <span class="text-xs text-n-slate-11">
          {{ t('ICERIK.IST_GONDERI_SAYISI') }}:
          <span class="font-medium text-n-slate-12">
            {{ sayi(ozet.profil.gonderi) }}
          </span>
        </span>
      </section>

      <!-- Hesap kartlari -->
      <section class="grid gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6">
        <div
          v-for="kart in KARTLAR"
          :key="kart.alan"
          class="flex items-center gap-3 p-4 border rounded-xl border-n-weak bg-n-solid-1"
        >
          <span
            class="grid shrink-0 rounded-lg size-10 place-content-center bg-n-alpha-1"
          >
            <span :class="[kart.simge, kart.renk]" class="size-5" />
          </span>
          <span class="flex flex-col min-w-0 gap-0.5">
            <span class="text-xl font-semibold leading-none text-n-slate-12">
              {{ ozetDegeri(kart.alan) }}
            </span>
            <span class="text-xs truncate text-n-slate-11">
              {{ t(kart.anahtar) }}
            </span>
          </span>
        </div>
      </section>

      <!-- Eksik metrikleri GIZLEMIYORUZ: hangi sayinin neden bos oldugunu
           soylemek, sessizce sifir gostermekten iyidir. -->
      <p v-if="ozet.eksikler && ozet.eksikler.length" class="text-xs text-n-amber-11">
        {{ t('ICERIK.IST_EKSIK', { metrikler: ozet.eksikler.join(', ') }) }}
      </p>

      <!-- Gonderi bazli -->
      <section class="flex flex-col gap-3">
        <h3 class="text-sm font-medium text-n-slate-12">
          {{ t('ICERIK.IST_GONDERI_BASLIK') }}
        </h3>

        <div v-if="gonderiYukleniyor" class="flex justify-center p-6">
          <Spinner class="text-n-brand" />
        </div>

        <p v-else-if="!gonderiler.length" class="text-xs text-n-slate-11">
          {{ t('ICERIK.IST_GONDERI_YOK') }}
        </p>

        <ul v-else class="flex flex-col gap-2 list-none">
          <li
            v-for="gonderi in gonderiler"
            :key="gonderi.medya_id"
            class="border rounded-xl border-n-weak bg-n-solid-1"
          >
            <button
              type="button"
              class="flex items-center w-full gap-3 p-3 text-left"
              @click="medyaSec(gonderi)"
            >
              <img
                v-if="gonderi.gorsel_url && !gorselHatasi.has(gonderi.medya_id)"
                :src="gonderi.gorsel_url"
                alt=""
                class="object-cover rounded-lg shrink-0 size-12 bg-n-alpha-1"
                @error="gorseliGizle(gonderi.medya_id)"
              />
              <span
                v-else
                class="grid rounded-lg shrink-0 size-12 place-content-center bg-n-alpha-1 text-n-slate-10"
              >
                <span class="i-lucide-image size-4" />
              </span>

              <span class="flex flex-col min-w-0 gap-0.5 grow">
                <span class="text-sm truncate text-n-slate-12">
                  {{ metinOzeti(gonderi.metin) }}
                </span>
                <span class="text-xs text-n-slate-11">
                  {{ zaman(gonderi.yayin_zamani) }}
                </span>
              </span>

              <span
                class="text-xs shrink-0 text-n-slate-11"
                :class="
                  seciliMedya === gonderi.medya_id ? 'i-lucide-chevron-up' : 'i-lucide-chevron-down'
                "
              />
            </button>

            <div
              v-if="seciliMedya === gonderi.medya_id"
              class="px-3 pb-3"
            >
              <div
                v-if="!medyaSayilari[gonderi.medya_id]"
                class="flex justify-center p-4"
              >
                <Spinner class="text-n-brand" />
              </div>
              <div v-else class="flex flex-col gap-3">
                <!-- Reklama verilmemis gonderi: tek sutun yeter. -->
                <template v-if="!reklamliMi(medyaSayilari[gonderi.medya_id])">
                  <div class="grid gap-2 sm:grid-cols-3 lg:grid-cols-6">
                    <div
                      v-for="s in medyaSayilari[gonderi.medya_id].karsilastirma"
                      :key="s.alan"
                      class="flex flex-col gap-0.5 px-3 py-2 rounded-lg bg-n-alpha-1"
                    >
                      <span class="text-base font-medium text-n-slate-12">
                        {{ sayi(s.organik) }}
                      </span>
                      <span class="text-xs text-n-slate-11">
                        {{ metrikAdi(s.alan) }}
                      </span>
                    </div>
                    <div
                      v-for="(deger, alan) in medyaSayilari[gonderi.medya_id]
                        .yalnizOrganik"
                      :key="alan"
                      class="flex flex-col gap-0.5 px-3 py-2 rounded-lg bg-n-alpha-1"
                    >
                      <span class="text-base font-medium text-n-slate-12">
                        {{ sayi(deger) }}
                      </span>
                      <span class="text-xs text-n-slate-11">
                        {{ metrikAdi(alan) }}
                      </span>
                    </div>
                  </div>
                  <p class="text-xs text-n-slate-11">
                    {{ t('ICERIK.IST_TUMU_ORGANIK') }}
                  </p>
                </template>

                <!-- One cikarilan gonderi: ayni tanima sahip metrikler yan
                     yana. Reklam kopyasi AYRI bir medya oldugu icin iki
                     tarafin sayilari ust uste binmiyor, toplamak dogru. -->
                <template v-else>
                  <table class="w-full text-sm">
                    <thead>
                      <tr class="text-xs text-left text-n-slate-11">
                        <th class="py-1.5 font-normal">
                          {{ t('ICERIK.IST_METRIK') }}
                        </th>
                        <th class="py-1.5 font-normal text-right">
                          {{ t('ICERIK.IST_ORGANIK') }}
                        </th>
                        <th class="py-1.5 font-normal text-right">
                          {{ t('ICERIK.IST_REKLAM') }}
                        </th>
                        <th class="py-1.5 font-normal text-right">
                          {{ t('ICERIK.IST_TOPLAM') }}
                        </th>
                        <th class="py-1.5 font-normal text-right">
                          {{ t('ICERIK.IST_REKLAM_PAYI') }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="s in medyaSayilari[gonderi.medya_id].karsilastirma"
                        :key="s.alan"
                        class="border-t border-n-weak"
                      >
                        <td class="py-1.5 text-n-slate-11">
                          {{ metrikAdi(s.alan) }}
                        </td>
                        <td class="py-1.5 text-right text-n-slate-12">
                          {{ sayi(s.organik) }}
                        </td>
                        <td class="py-1.5 text-right text-n-teal-11">
                          {{ sayi(s.reklam) }}
                        </td>
                        <td class="py-1.5 font-medium text-right text-n-slate-12">
                          {{ sayi(s.toplam) }}
                        </td>
                        <td class="py-1.5 text-right">
                          <span
                            v-if="s.reklam_payi !== null"
                            class="px-1.5 py-0.5 rounded text-xs"
                            :class="
                              s.reklam_payi >= 50
                                ? 'text-n-teal-11 bg-n-alpha-1'
                                : 'text-n-slate-11'
                            "
                          >
                            %{{ s.reklam_payi }}
                          </span>
                          <span v-else class="text-n-slate-10">—</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <!-- Karsiligi tek tarafta olan metrikler. Diger sutuna
                       sifir yazmak "hic olmadi" demek olurdu; oysa Meta o
                       tarafta bu metrigi HIC vermiyor. -->
                  <div class="grid gap-3 sm:grid-cols-2">
                    <div class="flex flex-col gap-1.5 p-3 rounded-lg bg-n-alpha-1">
                      <span class="text-xs font-medium text-n-slate-11">
                        {{ t('ICERIK.IST_YALNIZ_ORGANIK') }}
                      </span>
                      <span
                        v-for="(deger, alan) in medyaSayilari[gonderi.medya_id]
                          .yalnizOrganik"
                        :key="alan"
                        class="flex justify-between text-sm"
                      >
                        <span class="text-n-slate-11">{{ metrikAdi(alan) }}</span>
                        <span class="text-n-slate-12">{{ sayi(deger) }}</span>
                      </span>
                    </div>

                    <div class="flex flex-col gap-1.5 p-3 rounded-lg bg-n-alpha-1">
                      <span class="text-xs font-medium text-n-teal-11">
                        {{ t('ICERIK.IST_YALNIZ_REKLAM') }}
                      </span>
                      <span
                        v-for="(deger, alan) in medyaSayilari[gonderi.medya_id]
                          .yalnizReklam"
                        :key="alan"
                        class="flex justify-between text-sm"
                      >
                        <span class="text-n-slate-11">{{ metrikAdi(alan) }}</span>
                        <span class="text-n-slate-12">{{ sayi(deger) }}</span>
                      </span>
                      <span
                        v-if="paraMetni(medyaSayilari[gonderi.medya_id])"
                        class="flex justify-between text-sm"
                      >
                        <span class="text-n-slate-11">
                          {{ t('ICERIK.IST_HARCAMA') }}
                        </span>
                        <b class="text-n-slate-12">
                          {{ paraMetni(medyaSayilari[gonderi.medya_id]) }}
                        </b>
                      </span>
                    </div>
                  </div>

                  <div
                    class="flex flex-wrap items-center gap-3 px-3 py-2 text-xs rounded-lg bg-n-alpha-1 text-n-slate-11"
                  >
                    <span class="i-lucide-megaphone size-3.5 text-n-teal-11" />
                    <span>
                      {{
                        t('ICERIK.IST_REKLAM_SAYISI', {
                          sayi: medyaSayilari[gonderi.medya_id].kopyalar.length,
                        })
                      }}
                    </span>
                    <a
                      v-for="(k, i) in medyaSayilari[gonderi.medya_id].kopyalar"
                      :key="i"
                      :href="k.permalink"
                      target="_blank"
                      rel="noopener"
                      class="underline text-n-blue-11"
                    >
                      {{ k.ad || t('ICERIK.IST_REKLAM') }}
                    </a>
                  </div>
                </template>
              </div>
            </div>
          </li>
        </ul>
      </section>
    </template>
  </div>
</template>
